<mat-toolbar>
  <mat-toolbar-row>
    <span
      >Hello,
      <span class="email">{{
        formatUserName((userData$ | async)?.userData.email || 'Guest')
      }}</span></span
    >
    <span class="spacer"></span>
    <!-- Reveal Code Input -->
    <div class="flex items-center plan-number mr-6">
      <mat-form-field appearance="outline">
        <mat-hint>Enter code to reveal plan numbers</mat-hint>
        <mat-label>Reveal Code</mat-label>
        <input
          matInput
          [(ngModel)]="revealCode"
          (input)="onRevealCodeChange()"
          placeholder="Code"
          type="password"
        />
        <mat-icon
          matSuffix
          [style.color]="isPlanNumberRevealed ? 'green' : 'red'"
          class="text-sm"
        >
          {{ isPlanNumberRevealed ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </mat-form-field>
    </div>

    <button
      mat-button
      color="primary"
      class="mr-4"
      routerLink="/check-tmti-redirections"
    >
      TMTI redirections
    </button>

    <button
      mat-button
      color="primary"
      class="mr-4"
      routerLink="/conversation-history"
    >
      Conversation history
    </button>

    <button
      mat-button
      color="primary"
      class="mr-4"
      routerLink="/fire-safety-check"
    >
      Fire safety
    </button>

    <button
      mat-button
      color="primary"
      class="mr-4"
      routerLink="/voice2voice-transcripts"
    >
      Voice2Voice Transcripts
    </button>

    <button
      mat-button
      color="primary"
      class="mr-4"
      routerLink="/conversation-quality"
    >
      Conversation Quality
    </button>

    <button matButton="tonal" color="accent" (click)="logout()">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>

<section
  class="table-summary-strip"
  aria-label="Approximate platform record counts"
>
  <div class="table-summary-strip__brand">
    <mat-icon>analytics</mat-icon>
    <span>Platform pulse</span>
  </div>

  <div class="table-summary-strip__metrics" aria-live="polite">
    <div class="table-summary-strip__metric">
      <mat-icon>record_voice_over</mat-icon>
      <span>Voice2Voice</span>
      @if (voiceToVoiceTranscriptSummary) {
        <strong>{{ voiceToVoiceTranscriptSummary.totalItems | number }}</strong>
      } @else if (isLoadingVoiceToVoiceTranscriptSummary) {
        <strong class="is-loading">…</strong>
      } @else {
        <strong>—</strong>
      }
    </div>

    <span class="table-summary-strip__divider" aria-hidden="true"></span>

    <div class="table-summary-strip__metric">
      <mat-icon>chat</mat-icon>
      <span>Text conversations</span>
      @if (agentLLMTextConversationCount !== null) {
        <strong>{{ agentLLMTextConversationCount | number }}</strong>
      } @else if (isLoadingTableInfo) {
        <strong class="is-loading">…</strong>
      } @else {
        <strong>—</strong>
      }
    </div>
    <div class="table-summary-strip__metric">
      <mat-icon>forum</mat-icon>
      <span>Total conversations</span>
      @if (totalConversationCount !== null) {
        <strong>{{ totalConversationCount | number }}</strong>
      } @else if (isLoadingTotalConversationCount) {
        <strong class="is-loading">…</strong>
      } @else {
        <strong>—</strong>
      }
    </div>
  </div>
</section>

<div class="dashboard-table">
  <div class="analytics-grid">
    <div class="analytics-date-filter">
      <mat-card>
        <mat-card-content>
          <mat-card-title>Analytics Date Filter</mat-card-title>
          <div class="date-filter-controls">
            <mat-form-field appearance="fill">
              <mat-label>Start Date</mat-label>
              <input
                matInput
                [matDatepicker]="analyticsStartPicker"
                [(ngModel)]="analyticsStartDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="analyticsStartPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #analyticsStartPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>End Date</mat-label>
              <input
                matInput
                [matDatepicker]="analyticsEndPicker"
                [(ngModel)]="analyticsEndDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="analyticsEndPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #analyticsEndPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Solution Type</mat-label>
              <mat-select [(ngModel)]="solutionType">
                @for (solution of solutionTypeOptions; track solution) {
                  <mat-option [value]="solution.value">{{
                    solution.label
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <div class="filter-buttons">
              <button
                mat-raised-button
                color="primary"
                (click)="filterAnalyticsData()"
                [disabled]="isLoadingAnalytics"
              >
                <mat-icon>filter_list</mat-icon>
                Filter
              </button>

              <button
                mat-stroked-button
                color="accent"
                (click)="clearAnalyticsDateFilter()"
                [disabled]="isLoadingAnalytics"
              >
                <mat-icon>clear</mat-icon>
                Clear Filter
              </button>

              <button
                mat-icon-button
                color="primary"
                (click)="refreshAnalyticsData()"
                [disabled]="isLoadingAnalytics"
                matTooltip="Refresh analytics data"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <app-analytics-widget
      [data]="analyticsData"
      [isLoading]="isLoadingAnalytics"
      (fetchImageData)="openImageConversationsDialog($event)"
    ></app-analytics-widget>
  </div>

  <div>
    <app-rag-vs-agentic-widget
      [trendData]="ragVsAgenticTrendData"
      [isLoadingTrend]="isLoadingRagVsAgenticTrend"
      [trendProgress]="ragVsAgenticTrendProgress"
      [trendProgressMessage]="ragVsAgenticTrendProgressMessage"
      [trendStartDate]="ragVsAgenticTrendStartDate"
      [trendEndDate]="ragVsAgenticTrendEndDate"
      [snapshotData]="ragVsAgenticSnapshotData"
      [isLoadingSnapshot]="isLoadingRagVsAgenticSnapshot"
      (trendFilter)="filterRagVsAgenticTrendData()"
      (trendClear)="clearRagVsAgenticTrendFilter()"
      (trendStartDateChange)="ragVsAgenticTrendStartDate = $event"
      (trendEndDateChange)="ragVsAgenticTrendEndDate = $event"
    ></app-rag-vs-agentic-widget>
  </div>

  <!-- Time Series Chart Section with Independent Filters -->
  <div class="time-series-section">
    <mat-card>
      <mat-card-content>
        <mat-card-title
          ><mat-icon>timeline</mat-icon> Time Series Analysis</mat-card-title
        >
        <div class="time-series-filter-controls">
          <mat-form-field appearance="fill">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="timeSeriesStartPicker"
              [(ngModel)]="timeSeriesStartDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="timeSeriesStartPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #timeSeriesStartPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="timeSeriesEndPicker"
              [(ngModel)]="timeSeriesEndDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="timeSeriesEndPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #timeSeriesEndPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Solution Type</mat-label>
            <mat-select [(ngModel)]="timeSeriesSolutionType">
              @for (solution of solutionTypeOptions; track solution) {
                <mat-option [value]="solution.value">{{
                  solution.label
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="filter-buttons">
            <button
              mat-raised-button
              color="primary"
              (click)="filterTimeSeriesData()"
              [disabled]="isLoadingTimeSeries"
            >
              <mat-icon>filter_list</mat-icon>
              Generate Chart
            </button>

            <button
              mat-stroked-button
              color="accent"
              (click)="clearTimeSeriesFilter()"
              [disabled]="isLoadingTimeSeries"
            >
              <mat-icon>clear</mat-icon>
              Clear
            </button>

            <button
              mat-icon-button
              color="primary"
              (click)="refreshTimeSeriesData()"
              [disabled]="isLoadingTimeSeries"
              matTooltip="Refresh time series data"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <!-- Progress Bar -->
        @if (isLoadingTimeSeries) {
          <div class="progress-container">
            <div class="progress-info">
              <span class="progress-message">{{
                timeSeriesProgressMessage
              }}</span>
              <span class="progress-percentage">{{ timeSeriesProgress }}%</span>
            </div>
            <mat-progress-bar
              mode="determinate"
              [value]="timeSeriesProgress"
              color="primary"
            ></mat-progress-bar>
          </div>
        }
      </mat-card-content>
    </mat-card>

    <app-time-series-chart
      [data]="timeSeriesData"
      [isLoading]="isLoadingTimeSeries"
    ></app-time-series-chart>
  </div>

  <app-table-info-widget [data]="tableInfo"></app-table-info-widget>

  <section
    class="table-summary-details"
    aria-labelledby="table-summary-details-title"
  >
    <div class="table-summary-details__heading">
      <span class="eyebrow">Database detail</span>
      <h2 id="table-summary-details-title">Voice and text table information</h2>
    </div>
    <div class="table-summary-grid">
      <app-table-summary-widget
        title="Voice2Voice Transcripts"
        [summary]="voiceToVoiceTranscriptSummary"
        [isLoading]="isLoadingVoiceToVoiceTranscriptSummary"
        [error]="hasVoiceToVoiceTranscriptSummaryError"
      ></app-table-summary-widget>

      <app-table-summary-widget
        title="Text Conversations"
        [summary]="textConversationSummary"
        [isLoading]="isLoadingTableInfo"
        [error]="hasTableInfoError"
      ></app-table-summary-widget>
    </div>
  </section>

  <div class="flex justify-center items-center mt-8">
    <div class="bg-gray-100 p-4 rounded-lg shadow-md">
      <p class="text-lg font-semibold text-gray-700 flex items-center">
        Copy id token for apiUsage
        <mat-icon
          class="ml-2 cursor-pointer text-blue-500 hover:text-blue-700 transition-colors"
          (click)="copyIdToken()"
        >
          content_copy
        </mat-icon>
      </p>
    </div>
  </div>
</div>
